import Link from 'next/link';
import Image from 'next/image';

function BlogItem({post}) {
    return (
                <div className="col-lg-4 col-md-6 ">
					<div className="dlab-blog style-1 bg-white text-center m-b50">
                        <div className="dlab-media dlab-img-effect zoom">
                            <Link legacyBehavior href={"/blog/"+post.slug}>
                                <a href={"/blog/"+post.slug} title={post.title}><Image width="370" height="172" src={post.image} alt={post.title} /></a>
                            </Link>
                        </div>
                        <div className="dlab-info">
                            <h4 className="dlab-title">
                                <Link legacyBehavior href={"/blog/"+post.slug}>
                                    <a href={"/blog/"+post.slug} title={post.title}>{post.title.substring(1,50)}</a>
                                </Link>
                            </h4>
                            <p className="m-b0">{post.short_description.substring(1,150)}</p>
                            <div className="dlab-meta meta-bottom">
                                <ul>
                                    <li className="post-date"><i className="flaticon-clock m-l10"></i>{post.created_at}</li>
                                    <li className="post-author"><i className="fa fa-user m-l10"></i>eSmart Team</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )
  }
  
  export default BlogItem;